var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6272 18.6272 24 12 24C5.37278 24 0 18.6272 0 12C0 5.37278 5.37278 0 12 0C18.6272 0 24 5.37278 24 12Z",
    fill: "#0A7BBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1697 12.9667V17.9143H16.3016V13.2988C16.3016 12.1395 15.888 11.3477 14.8487 11.3477C14.057 11.3477 13.5859 11.8815 13.378 12.3975C13.3018 12.5813 13.283 12.8372 13.283 13.0962V17.9144H10.4138C10.4138 17.9144 10.4525 10.0965 10.4138 9.28715H13.283V10.5101C13.2778 10.5195 13.2695 10.5288 13.2642 10.5382H13.283V10.5101C13.6643 9.92319 14.3442 9.08439 15.8681 9.08439C17.7555 9.08439 19.1697 10.3179 19.1697 12.9667ZM7.41414 5.12891C6.4323 5.12891 5.79102 5.77335 5.79102 6.6194C5.79102 7.44764 6.41353 8.10975 7.37655 8.10975H7.39431C8.39492 8.10975 9.01743 7.44769 9.01743 6.6194C8.99862 5.7734 8.39492 5.12891 7.41414 5.12891ZM5.96127 17.9144H8.82836V9.28715H5.96127V17.9144Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinRounded);
export default __webpack_public_path__ + "static/media/linkedin-rounded.6e4556a8a09e613bbce173421697265f.svg";
export { ForwardRef as ReactComponent };